/* Shop category bar — fills each mega panel's Top Brands rail with the five most
   common vendors in that collection (mirrors ShopSecondaryNav.tsx, which tallies
   vendors per category via the Storefront API). */
(function () {
  var root = document.querySelector('[data-secondary-nav]');
  if (!root || root.dataset.brandsInit) return;
  root.dataset.brandsInit = '1';

  var token = root.dataset.storefrontToken;
  if (!token || !window.Shopify || !window.Shopify.shop) return;

  var endpoint = 'https://' + window.Shopify.shop + '/api/2025-07/graphql.json';
  var query = 'query($h: String!) { collection(handle: $h) {' +
    ' products(first: 250) { edges { node { vendor } } } } }';

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  function fill(el, handle) {
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
      body: JSON.stringify({ query: query, variables: { h: handle } })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var edges = d && d.data && d.data.collection && d.data.collection.products.edges;
        if (!edges || !edges.length) { el.innerHTML = ''; return; }
        var counts = {};
        edges.forEach(function (e) {
          var v = e.node.vendor;
          if (v) counts[v] = (counts[v] || 0) + 1;
        });
        var top = Object.keys(counts)
          .sort(function (a, b) { return counts[b] - counts[a]; })
          .slice(0, 5);
        el.innerHTML = top.map(function (brand) {
          return '<a href="/collections/vendors?q=' + encodeURIComponent(brand) +
            '" class="block text-sm text-muted-foreground hover:text-primary transition-colors">' + esc(brand) + '</a>';
        }).join('');
      })
      .catch(function () {});
  }

  root.querySelectorAll('[data-top-brands]').forEach(function (el) {
    fill(el, el.getAttribute('data-top-brands'));
  });
})();
